import React from "react";
import { X } from "lucide-react";

const ProductInterestModal = ({
    isOpen,
    onClose,
    children,
}) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[99999] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4">
            <div className="bg-white rounded-3xl shadow-2xl w-full max-w-[80vw] max-h-[90vh] overflow-hidden">

                <div className="flex items-center justify-between border-b px-6 py-5 bg-gradient-to-r from-teal-600 to-cyan-600 text-white">
                    <h2 className="text-2xl font-bold !text-white">
                        Product Interest
                    </h2>

                    <button
                        onClick={onClose}
                        className="p-2 rounded-xl hover:bg-white/20 transition"
                    >
                        <X size={24} />
                    </button>
                </div>

                <div className="p-6 overflow-y-auto max-h-[78vh]">
                    {children}
                </div>

            </div>
        </div>
    );
};

export default ProductInterestModal;